import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./firebase";
import "./helpers.css";
import "./index.css";
import "./style_css/fonts.css";
import initGlobalErrorHandler from "./utils/globalErrorHandler";
import reportWebVitals from "./utils/reportWebVitals"; // Assuming container is not null because there is no fallback
import { isInIframe } from "./utils/iframeUtils";
import { persistUrlFlagsFromSearch } from "./utils/urlFlags";

const container = document.getElementById("root");

const root = createRoot(container!);

document.documentElement.dataset.inIframe = String(isInIframe());

initGlobalErrorHandler();
persistUrlFlagsFromSearch();
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
